/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState} from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Helmet]
-------------------------------------------------------------------*/
import {Helmet} from "react-helmet";
/*------------------------------------------------------------------
[End React Helmet]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_PUBLIC, API_UPLOADS } from '../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Module]
-------------------------------------------------------------------*/
import { decode } from "html-entities";
import ReactPlayer from "react-player"
import LinesEllipsis from 'react-lines-ellipsis'
/*------------------------------------------------------------------
[End React Module]
-------------------------------------------------------------------*/

const Screen = ({loading, error}) => {

    const [data, set_data] = useState(null);

    const [pagination_active, set_pagination_active] = useState(1);

    const _read = (pages) => {

        let offsetSync;

        if(pages === 1){
            
            offsetSync = 0;    
        
        }else{

            offsetSync = pages ? (12 * pages) - 12 : 0
        
        }
        
        loading(true);

        API_GET_PUBLIC(`client/profile__________?limit=12&offset=${offsetSync}`)
        .then((response) => {
            if(response.data.result === 'success'){
                loading(false)
                set_data(response.data.data)
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
            console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

    }
    
    useEffect(() => {
        
		_read()

    }, [])

	return (
		<>
            <Helmet>

                <meta name="description" content={'Profile'}/>
                <title>{'Profile'}</title>

            </Helmet>

            <div className="_container">
                <div className="_lily_pad_h_d __section_pages_title">
                    <h1>Profile</h1>
                </div>
            </div>
            <div>
				<div className="_container">
					<div className="_row_sync">
                        {
                            data ?
                                data.profile.map((item, index) => (
                                    <div 
                                        key={index} 
                                        className="_column_sync"
                                    >
                                        <div className="__card_testimonial" style={{backgroundImage: `url(${API_UPLOADS + item.image})`}}>

                                        </div>
                                        <LinesEllipsis
                                            style={{marginTop: 10, color: '#444'}}
                                            text={decode(item.title)}
                                            maxLine='2'
                                            ellipsis='...'
                                            trimRight
                                            basedOn='letters'
                                        />
                                        <LinesEllipsis
                                            style={{marginTop: 6}}
                                            text={decode(item.description)}
                                            maxLine='2'
                                            ellipsis='...'
                                            trimRight
                                            basedOn='letters'
                                        />
                                    </div>
                                ))
                            : 
                                new Array(4).fill(undefined).map((index) => (
                                    <div key={index} className="_column_sync">
                                        <div className="__card_testimonial"/>
                                    </div>
                                ))
                        }
                    </div>
				</div>
			</div>
            <div className="_container">
                <div className="_lily_pad_h_d">
                    <div className="__pagination">
                        {
                            data&&data.pages.map((item, index) => {
                                if(data.pages.length > 1){
                                    return (

                                        <div 
                                            key={index} 
                                            className="__item"
                                            style={{backgroundColor: pagination_active === index + 1 ? '#eee' : '#fff'}}
                                            onClick={() => {
                                                _read(index + 1);
                                                set_pagination_active(index + 1)
                                            }}
                                        >
                                            <div className="_position_middle">
                                                {item}
                                            </div>
                                        </div>
                                        
                                    )
                                }
                            })
                        }
                    </div>
                </div>
            </div>
		
        </>
	);
}

export default Screen;